import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/week/styles.scss';export default {
  "week": "_week_ueoce_1",
  "day": "_day_ueoce_8",
  "odd": "_odd_ueoce_18",
  "today": "_today_ueoce_21",
  "weekEnd": "_weekEnd_ueoce_24",
  "name": "_name_ueoce_28",
  "nbr": "_nbr_ueoce_36"
};